import PropTypes from 'prop-types';
import React from 'react';
import { Box } from '@mui/material';

/**
 * Ekrandaki açıklama kutusu. Rakamın ne anlama geldiğini yanı başında
 * söylemek, mutabakat ekranında rakamın kendisi kadar önemli.
 */
const InfoNote = ({ children, sx }) => (
  <Box
    sx={(theme) => ({
      fontSize: '0.8125rem',
      lineHeight: 1.6,
      color: 'text.secondary',
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,.03)' : theme.palette.grey[50],
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 1,
      px: 1.75,
      py: 1.5,
      '& b': { color: 'text.primary', fontWeight: 500 },
      '& code': {
        fontFamily: 'ui-monospace, Menlo, Consolas, monospace',
        fontSize: '0.75rem',
        backgroundColor:
          theme.palette.mode === 'dark' ? 'rgba(255,255,255,.07)' : theme.palette.grey[200],
        px: 0.6,
        py: '1px',
        borderRadius: 0.5
      },
      ...sx
    })}
  >
    {children}
  </Box>
);

InfoNote.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object
};

export default InfoNote;
